import React, { useEffect, useRef, useState } from "react";
import "../Styles/VideoPlayer.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Favfill from "../assets/img/favadd.svg";
import Loader from "./Loader";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Reset from "../Images/reset.png";
import VideoService from "../Services/VideoPlayer";
import Tooltip from "@mui/material/Tooltip";

import Favempty from "../assets/img/fav.svg";
import { Skeleton } from "@mui/material";
// import { CloseIcon } from "../Components/EpubReader/Components";
import CloseIcon from "@mui/icons-material/Close";
import i18n from "../i18n";
import AuthorsService from "../Services/Authors";
import AccordionSidebar from "./AccordionSidebar";
// import axios from "axios";
import { LogInModel } from "./LoginModel";
import { useAudio } from "../Contexts/AudiosContext";
import VideoDialog from "./VideoDialog";
import { useVideo } from "../Contexts/VideosContext";
import { ListPagination } from "../Components";


const VideoPlayerPage = () => {
  const location = useLocation();
  const state = location.state as {
    videoId: string;
    videoImage: string;
    videoName: string;
    videoClicked: boolean;
    authorId: string;
    categoryId: string;
    vidId: string;
    videoSlug: string;
    from: string
  };

  const [thumbUrls, setThumbUrls] = useState<any>([]);
  // const [videoId, setVideoId] = useState<any | string[]>([]);
  const [filteredCategoryId, setFilteredCategoryId] = useState<any | string[]>(
    []
  );

  // const [isLiked, setIsLiked] = useState<boolean>(false);
  const { youtubeTitle, setYoutubetitle } = useVideo()
  const [selectedParentId, setSelectedParentId] = useState<
    string | number | null
  >(null);
  const [selectedSubId, setSelectedSubId] = useState<string | number | null>(
    null
  );
  const [authors, setAuthors] = useState<any>();

  const { t } = useTranslation();
  const [about, setAbout] = React.useState({
    __html: "",
  });

  // const [open, setOpen] = useState(false);
  const [isSelected, setIsselected] = useState<boolean>(false);
  const [viewState, setViewState] = useState<"home" | "category" | "video">(
    "home"
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [loadVideo, setLoadVideo] = useState<boolean>(false);
  const [categoryId, setCategoryId] = useState<any>(null);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [allVideos, setAllVideos] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [sort, setSort] = useState("0");
  const [page, setPage] = useState(1);
  const [authorId, setAuthorId] = useState<any>(null);
  const [authorClick, setAuthorClick] = useState<boolean>(false);
  const [refresh, setRefresh] = useState(false);

  const itemsPerPage = 12;
  const paginatedVideos = allVideos.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );
  const [selectedAuthorId, setSelectedAuthorId] = useState<string | null>(null);
  // const [likedMsg, setLikedMsg] = useState<any>(null);
  const [showMsg, setShowMsg] = useState<boolean>(false);
  const { playingAudio, setPlayingAudio, playVideo, setPlayVideo } = useAudio();

  useEffect(() => {
    const getCategories = async () => {
      setLoading(true);
      try {
        const res = await VideoService.getCategoryWiseVideos();
        if (res.result) {
          const categories = res.result;
          const enrichedCategories = await Promise.all(
            categories?.map(async (cat: any) => {
              const subRes = await VideoService.getCategoryWiseVideos(cat.id);
              const subItems = subRes.result[0]?.items || [];

              const subcategories = subItems.filter(
                (item: any) => item.type === 1
              );

              return {
                ...cat,
                items: subcategories,
              };
            })
          );
          setThumbUrls(enrichedCategories);
        } else {
          alert("No additional categories found.");
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        alert("Something went wrong.");
      } finally {
        setLoading(false);
      }
    };
    getCategories()
  }, [i18n?.language])

  const getAllVideos = async (
    categoryId?: string,
    authorId?: string,
    sort?: any,
    length: number = 500
  ) => {
    setLoadVideo(true)
    try {


      const response = await VideoService.getAllVideos(categoryId, authorId, sort, length);

      const items = response?.result?.items ?? [];
      const total = response?.result?.totalRecords ?? 0;

      if (response?.status && items.length) {
        setAllVideos(items);
        setTotalRecords(total);
      } else {
        console.warn("No videos found.");
        setAllVideos([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
      alert("Something went wrong while fetching videos.");
    } finally {
      setLoadVideo(false);
    }
  };

  useEffect(() => {
    const category = state?.categoryId ?? categoryId;
    const author = state?.authorId ?? authorId;

    getAllVideos(category, author, sort);
  }, [i18n.language, sort, state?.categoryId, categoryId, state?.authorId, authorId, refresh]);

  useEffect(() => {
    const getAuthors = (authorfor?: any, limit?: any) => {
      setLoading(true);
      AuthorsService.getAuthorData((authorfor = 9), (limit = null))
        .then((res) => {
          if (res?.status && res?.result) {
            const response = res?.result;
            setAuthors(response);
          } else {
            alert("No authors found");
          }
        })
        .catch((error) => {
          console.error("Error fetching in authors:", error);
          alert("Something went wrong while fetching authors");
        })
        .finally(() => {
          setLoading(false);
        });
    };
    getAuthors()
  }, [i18n?.language])

  function ResetData() {
    setPage(1);
    setFilteredCategoryId(null);
    setSelectedCategoryName("");
    setViewState("home");
    setCategoryId(null);
    setAuthorId(null);
    setSelectedAuthorId(null);
    setSort("0");
    setIsselected(false);
    setSelectedSubId("");
    setSelectedParentId("");
    navigate(location.pathname, { state: null, replace: true });
    getAllVideos("", "", "0", 500);
    setIsselected(false);
    setAuthorClick(false);
    setRefresh(true);
  }

  const {
    setOpen,
    setVideoId,
    isLiked,
    setIsLiked,
    setLikedMsg,
    videoObjId,
    setVideoObjId
  } = useVideo();

  const handleCategoryClick = (categoryId: string, categoryName: string) => {
    setLoading(true);
    VideoService.getCategoryWiseVideos(categoryId)
      .then((res) => {
        if (res.result) {
          const items = res.result[0]?.items || [];
          const subcategories: any[] = [];
          const videos: any[] = [];

          // Loop through items and segregate into subcategories and videos
          items.forEach((item: any) => {
            if (item.type === 1) {
              subcategories.push(item);
            } else if (item.type === 2) {
              videos.push(item);
            }
          });
          setPage(1)
          // Update state based on the processed data
          setThumbUrls((prevThumbUrls: any[]) => {
            // Find the clicked category and add subcategories to it
            return prevThumbUrls?.map((category) => {
              if (category.id === categoryId) {
                return { ...category, items: subcategories };
              }
              return category;
            });
          });

          if (videos.length > 0) {
            setAllVideos(videos); // Set video items on the right side of the page
          } else {
            setAllVideos([]); // Clear videos if none exist
          }
          setCategoryId(categoryId);
          setFilteredCategoryId(categoryId);
          setSelectedCategoryName(categoryName);
          setSelectedAuthorId(null);
          setAuthorId(null);
          setAuthorClick(false);
        } else {
          alert("No additional categories or videos found.");
        }
      })
      .catch((error) => {
        console.error("Error fetching category data:", error);
        alert("Something went wrong while fetching category data.");
      })
      .finally(() => {
        setLoading(false);
      });
    // VideoService.getAllVideos(categoryId)
    //   .then((res) => {
    //     if (res.status && res.result?.items?.length) {
    //       setTotalRecords(res?.result?.totalRecords);
    //     } else {
    //       console.error("No videos found.");
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching video categories:", error);
    //     alert("Something went wrong while fetching videos.");
    //   })
  };

  const [logIn, setLogIn] = useState<boolean>(false);
  const closeModal = () => {
    setLogIn(false);
  };
  const handleClick = () => {
    if (logIn) {

    } else {
      setLogIn(true);
    }
  };

  const handleLoginStateChange = (newState: any) => {
  };

  const navigate = useNavigate();

  const shouldShowpagination = allVideos.length > itemsPerPage;

  useEffect(() => {
    const checkFavouriteStatus = async () => {
      const currentTime = new Date().toISOString();
      const pathsegements = window.location.pathname.split("/");
      const firstParam = pathsegements[1];
      if (state?.videoId) {
        console.log("yha ruka hu");

        setOpen(true);
        navigate(location.pathname, { replace: true });
        // setVideoId(state?.videoImage);
        // setYoutubetitle(state?.videoSlug);

        // If it sends a YouTube ID (11 chars), play directly without API
        if (state.videoId.length === 11) {
          setVideoId(state.videoId);
        } else {
          setVideoObjId(state?.videoId);
          VideoService.getSpecificVideo(state.videoId)
            .then((res: any) => {
              if (res?.result) {
                setYoutubetitle(res?.result?.name)
                setIsLiked(res.result.isFavourite);
                setVideoId(res?.result?.videoHash)
              }
            })
            .catch((err) => {
              console.error("Error checking favourite status:", err);
            });
          VideoService.updateUserActivity(
            firstParam,
            state?.videoId,
            currentTime
          );
        }
      }
    };
    checkFavouriteStatus();
  }, [state, navigate, location.pathname]);

  // useEffect(() => {
  //   getAuthors();
  // }, [i18n.language]);

  // useEffect(() => {
  //   getCategories();
  // }, [i18n.language]);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1400);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1400);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (state?.videoId) {
      console.log("video ki id aa rhi h", state?.videoId);
    }
  }, [location, state?.videoId]);

  return (
    <>

<div style={{ backgroundColor: "rgb(255, 237, 188)", padding: "0px 0px 0px 0px",marginTop:"-60px" }}>
      <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 10px",backgroundColor:"rgb(255, 237, 188)" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "20px",
                flexWrap: "wrap",
                padding: "28px 0 16px",
              }}
            >
              <div style={{ flex: "0 1 260px", minWidth: "220px" }}>
                <div style={{ padding: "8px 0" }}>
                  <h1 style={{ color: "#cf2c24", fontSize: "40px", margin: 0, fontWeight: 700,marginTop:"70px", textShadow: "0px 0px 4px rgba(255,255,255,0.9)" }}>
                    {t("Video_tr")}
                  </h1>
                  <div style={{ marginTop: "10px", fontSize: 19,fontWeight:600,color:"rgb(45, 42, 41)" }}>
                    <Link to="/" style={{ marginRight: "8px", color: "#2d2a29" }}>{t("Home_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <span>{t("Video_tr")}</span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "1px",
                  minHeight: "100px",
                  background: "#facc6f",
                  marginTop: "65px",
                }}
              />

              <div style={{ flex: "1 1 520px", minWidth: "300px" }}>
                <h2
                  style={{
                    textAlign: "center",
                    color: "rgb(228, 121, 7)",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
                    fontWeight: 600,
                    margin: 0,
                    paddingTop:"30px",
                    // marginb:"-10px",
                  }}
                >
                  {t("Videos_title_tr")}
                </h2>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                  <svg
                    width="26"
                    height="18"
                    viewBox="0 0 26 18"
                    style={{ margin: "0 12px" }}
                  >
                    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
                    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                  </svg>
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                </div>

                <p
                  style={{
                    fontSize: 17,
                    color: "#4a4036",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",
                    // margin: "25px 0 -10px",
                    margin:"18px 0px 0px 0px",
                    width: "100%",
                    lineHeight: 1.75,
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    textAlign: "center",
                  }}
                >
                  {t("Videos_description_tr")}
                </p>
              </div>
            </div>
      </div>
  </div>
      <div
        className="fontfamily"
        style={{
          userSelect: "none",
          backgroundColor: "rgb(255,246,225)",
          marginTop: "-3px",
          paddingTop: "1px",
        }}
      >
        <div className="containers">
          <div
            className="gst-page-content pagecontentbackground"
            style={{ backgroundColor: "#FFF6E1", paddingBottom: "3%" }}
          >
            <div className="row">
              <div className="col-lg-3">
                <div
                  className="detailbg"
                  style={{
                    padding: isMobile ? "10px 5px 0 10px" : "16px",
                    borderRadius: "4px",
                    background: "rgb(255, 250, 240)",
                    boxShadow: "rgb(245, 222, 177) 0px 0px 7px 1px",
                    height: "100%",
                    fontFamily: "ChanakyaUni",
                  }}
                >
                  <div className="cardbackground" style={{ cursor: "pointer" }}>
                    <span className="boxheadtitle">{t("Filter_tr")}</span>
                    {(categoryId !== null || authorId !== null || page > 1) && (
                      <img
                        alt="reset"
                        src={Reset}
                        className="resetimg"
                        onClick={() => {
                          ResetData()
                        }}
                      />
                    )}
                  </div>
                  <div style={{ backgroundColor: "#fffaec" }}>
                    <Accordion defaultExpanded elevation={0}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        style={{
                          height: 0,
                          background: "#FFFAF0",
                          minHeight: "20px",
                          // marginTop: 5,
                        }}
                      >
                        <h2 className="filtertitle" style={{ padding: "5px 0 10px 0"  }}>{t("categoriess_tr")}</h2>
                      </AccordionSummary>

                      <AccordionDetails
                        style={{ display: "block", background: "#FFFAF0", margin: "0 0 -15px 0" }}
                      >
                        <AccordionSidebar
                          items={thumbUrls}
                          onCategoryClick={(id: any, name: any) => {
                            handleCategoryClick(id, name);
                            setIsselected(true);
                          }}
                          isSelected={isSelected}
                          setSelectedParentId={setSelectedParentId}
                          setSelectedSubId={setSelectedSubId}
                          setFilteredCategoryId={setFilteredCategoryId}
                          setSelectedCategoryName={setSelectedCategoryName}
                          selectedParentId={selectedParentId}
                          selectedSubId={selectedSubId}
                        />
                      </AccordionDetails>
                    </Accordion>
                    <Accordion elevation={0}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        style={{
                          background: "#FFFAF0",
                          height: 0,
                          minHeight: "39px",
                          margin: "0 0 -7px 0",
                        }}
                      >
                        <h2 className="filtertitle">{t("Singer_tr")}</h2>
                      </AccordionSummary>

                      <AccordionDetails
                        style={{ display: "block", background: "#FFFAF0" }}
                      >
                        <div style={{ marginTop: "1px" }}>
                          {authors?.map((itm: any, index: number) => {
                            const isSelected = selectedAuthorId === itm?.id;
                            return (
                              <ul
                                key={index}
                                style={{
                                  color: "orange",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                  lineHeight: 1,
                                  marginTop: 5,
                                  marginLeft: "-11px",
                                  // backgroundColor: isSelected ? "#ffe0b2" : "transparent",
                                }}
                              >
                                <li>
                                  <span
                                    style={{
                                      color: isSelected ? "red" : "#545454",
                                      fontSize: "21px",
                                    }}
                                    onClick={() => {
                                      // setSelectedParentId("");
                                      // setSelectedSubId("");
                                      setSelectedAuthorId(itm?.id);
                                      setAuthorId(itm?.id);
                                      getAllVideos(categoryId, itm?.id);
                                      setAuthorClick(true);
                                    }}
                                  >
                                    {itm?.name}
                                  </span>

                                  {/* Show Subcategories if available */}
                                </li>
                              </ul>
                            );
                          })}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </div>

              <div className="col-lg-9">
                <div
                  className="detailbg"
                  style={{
                    overflowY: "auto",
                    padding: "16px",
                    borderRadius: "4px",
                    background: "rgb(255, 250, 240)",
                    boxShadow: "rgb(245, 222, 177) 0px 0px 7px 1px",
                    height: "100%",
                    fontFamily: "ChanakyaUni",
                  }}
                >
                  {allVideos && allVideos?.length > 0 ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            minWidth: "150px",
                            fontWeight: "bold",
                            fontSize: "20px",
                            marginTop: "10px",
                            marginLeft:"24px"
                          }}
                        >
                          {t("Total_Records_tr")} : <span>{totalRecords}</span>
                        </div>

                        <div className="filter1" style={{ textAlign: "right" }}>
                          <span>{t("Sort_tr")}</span>
                          <select
                            value={sort}
                            onChange={(e) => {
                              setSort(e.target.value);
                            }}
                            style={{
                              width: "178px",
                              backgroundColor: "rgb(255, 242, 213)",
                            }}
                          >
                            <option value="0">{t("General_tr")}</option>
                            <option value="3">{t("Popular_tr")}</option>
                            <option value="2">{t("Latest_tr")}</option>
                            <option value="1">{t("Title_tr")}</option>
                          </select>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3, 1fr)",
                          // !isMobile ? "repeat(3, 1fr)" : "repeat(2, 1fr)",
                          rowGap: "20px",
                          columnGap: isMobile ? "0px" : "40px",
                          padding: !isMobile ? "20px 50px 0px 35px" : "20px 50px 0px 5px",
                          width: !isMobile ? "90%" : "100%",
                        }}
                      >
                        {(loading ? Array.from(new Array(6)) : paginatedVideos)?.map((url, index) => (
                          <div key={index}>
                            {loading ? (
                              loadVideo && <Loader loading={loadVideo} />
                              // <>
                              //   <Skeleton variant="rectangular" width={240} height={135} style={{ borderRadius: "8px" }} />
                              //   <Skeleton width={240} height={30} style={{ marginTop: "8px" }} />
                              // </>
                            ) : (
                              <>
                                <img
                                  onClick={() => {
                                    if (localStorage.getItem("Token")) {

                                      setPlayVideo(!playVideo)
                                      VideoService.getSpecificVideo(url.id).then((res) => {
                                        if (res) {
                                          setIsLiked(res?.result?.isFavourite);
                                        }
                                      })
                                        .catch((err) => {
                                          //  setPlayVideo(true);
                                        });

                                      setSelectedCategoryName(url.name);
                                      setOpen(true);
                                      setVideoObjId(url?.id);
                                      setYoutubetitle(url?.name);
                                      setVideoId(
                                        url?.videoHash ? url?.videoHash : url?.categoryHash
                                      );

                                      debugger
                                      // console.log("selectedCategoryName", url?.name);
                                      // console.log("videoObjId", url?.id,);
                                      // console.log("youtubeTitle", url?.name);
                                      // console.log("hashId", url?.videoHash);

                                      // console.log("id",url?.id,"hash",url.videoHash,"name",url?.name);
                                      const currentTime = new Date().toISOString();
                                      const pathsegements = window.location.pathname.split("/");
                                      const firstParam = pathsegements[1];

                                      VideoService.updateUserActivity(
                                        firstParam,
                                        url?.id,
                                        currentTime
                                      );
                                    } else {
                                      setLogIn(true);
                                    }
                                  }}

                                  src={
                                    url.videoHash
                                      ? `https://img.youtube.com/vi/${url.videoHash}/hqdefault.jpg`
                                      : `https://img.youtube.com/vi/${url.categoryHash}/hqdefault.jpg`
                                  }
                                  alt={`Category ${index + 1}`}
                                  width={isMobile ? 224 : 240}
                                  height={135}
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                    cursor: "pointer",
                                  }}
                                />

                                <Tooltip title={<p style={{ fontSize: "13px" }}>{url.name}</p>} arrow placement="top">
                                  <h3
                                    style={{
                                      fontWeight: 600,
                                      fontSize: isMobile ? "19px" : "17px",
                                      marginTop: "8px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "242px",
                                      padding: "2px 0px 20px 0px",
                                    }}
                                  >
                                    {url.name?.length > 75 ? `${url.name.slice(0, 75)}...` : url.name}
                                  </h3>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        ))}
                      </div>

                      {shouldShowpagination && (
                        <div
                          style={{
                            display: "flex",
                            marginLeft: 30,
                            paddingTop: 15,
                          }}
                        >
                          {/* <div className="col-12" style={{ marginTop: "30px", display: pagination.totalRecords <= 12 ? "none" : "block" }}>
                            <ListPagination
                              totalRecords={pagination.totalRecords}
                              recordsPerPage={pagination.recordsPerPage}
                              currentPage={pagination.pageNo}
                              onClick={(p) => {
                                setPagination({
                                  ...pagination,
                                  pageNo: p,
                                });
                                setRefresh(true);
                              }}
                            />
                          </div> */}
                          <ListPagination
                            totalRecords={allVideos?.length}
                            recordsPerPage={itemsPerPage}
                            currentPage={page}
                            onClick={(value) => {
                              setPage(value)
                              setRefresh(true);
                            }}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    // <div className="ebooks-category resultnotfound">
                    //   {loading && <Loader loading={loading} />}
                    //   <label>{t("result_not_found_tr")}</label>
                    // </div>

                    <div className="ebooks-category resultnotfound">
                      {allVideos?.length === 0 ? (
                        loadVideo && <Loader loading={loadVideo} />
                        // ""
                      ) : (
                        <div>
                          <label>{t("result_not_found_tr")}</label>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <LogInModel
            opens={logIn}
            onCloses={closeModal}
            onLoginStateChange={handleLoginStateChange}
          />
        </div>
      </div>
    </>
  );
};

export default VideoPlayerPage;
